module.exports = __webpack_public_path__ + "static/media/chess-clock-alt.b54721c6.svg";